import { FormControl, InputLabel, Select, MenuItem, Box } from "@mui/material";
// filters option
const statusFiltersOptions = [
    {
        label: "الكل",
        value: "is_rejected:eq:true|false",
    },
    {
        label: "الطلبات الغير المرفوضة",
        value: "is_rejected:eq:false",
    },
    {
        label: "الطلبات  مرفوضة",
        value: "is_rejected:eq:true",
    },
];

const IsRegectedFilter = ({ filterValues, setFilterValues, setPage }) => {
    const handleChange = (e) => {
        setFilterValues({
            ...filterValues,
            is_rejected: e.target.value,
        });
        setPage("1");
    };
    return (
        <Box sx={{ minWidth: "230px", flex: "1" }}>
            <FormControl fullWidth>
                <InputLabel>مرفوض / غير مرفوض</InputLabel>
                <Select
                    name="is_rejected_filter"
                    value={filterValues.is_rejected}
                    label="مرفوض / غير مرفوض"
                    onChange={handleChange}
                    defaultValue={filterValues.is_rejected}
                >
                    {statusFiltersOptions.map((option) => {
                        return (
                            <MenuItem value={option.value} key={option.value}>
                                {option.label}
                            </MenuItem>
                        );
                    })}
                </Select>
            </FormControl>
        </Box>
    );
};

export default IsRegectedFilter;
